// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__MGX0p","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__1aoA-"};